import {Box, Container, Stack} from '@mui/material';
import InfoMeeting from './components/InfoMeeting';
import {useState} from 'react';
import ScreenCallLK from './components/ScreenCallLK';

export default () => {
    const [inCall, setInCall] = useState(false);

    return (
        <Box sx={{pt: 3, width: '100%', height: '100%', backgroundColor: 'black', position: 'relative'}}>
            <Container maxWidth="lg" sx={{position: 'sticky'}}>
                <InfoMeeting inCall={inCall} setInCall={setInCall} />
            </Container>
            {inCall && (
                <Stack justifyContent="center" height='100%' sx={{backgroundColor: 'black'}} maxHeight='calc(100% - 140px)'>
                    <ScreenCallLK />
                </Stack>
            )}
        </Box>
    );
};
